import { planService } from '../../../services';
import { PlanDetailsProps } from './PlanForm';

export const config: any = {
  getCompanyPlans: (companyName: string) =>
    planService.getPlanByCompany(companyName),
  getAllPlans: () => planService.getAllPlans(),
  addPlan: (payload: PlanDetailsProps) => planService.addPlan(payload),
  editPlan: (payload: any) => planService.editPlan(payload),
  deletePlan: (payload: any) => planService.deletePlan(payload),
  deleteFeature: (paylaod: any) => planService.deleteFeature(paylaod),
};
